import Modal from '../../../../components/ModalComponents/Modal';
import SalesInterviewsForm from './SalesInterviewsForm';

const SalesInterviewsModal = ({
  isOpen,
  onClose,
  onSubmit,
  register,
  errors,
  handleSubmit,
  setValue,
  watch,
  isSubmitting,
  refCandidate,
  refCandidateLoading,
  refVendor,
  refVendorLoading,
  refTechnologies,
  refTechnologiesLoading,
  jobs,
  selectedJob,
  onJobChange,
}) => {
  const isEditMode = !!watch('interviewId');

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="relative">
        {/* Submitting overlay */}
        {isSubmitting && (
          <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10 rounded-lg">
            <div className="flex flex-col items-center">
              <div className="w-8 h-8 border-4 border-secondary-200 border-t-secondary-700 rounded-full animate-spin mb-2"></div>
              <span className="text-secondary-700 font-medium">Saving...</span>
            </div>
          </div>
        )}

        {/* Modal Header with Close Button */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-secondary-800">
            {isEditMode ? 'Edit Interview' : 'Add Interview'}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-500 hover:text-secondary-800 text-2xl font-bold px-2"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <SalesInterviewsForm
          register={register}
          errors={errors}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          closeModal={onClose}
          setValue={setValue}
          watch={watch}
          isSubmitting={isSubmitting}
          refCandidate={refCandidate}
          refCandidateLoading={refCandidateLoading}
          refVendor={refVendor}
          refVendorLoading={refVendorLoading}
          refTechnologies={refTechnologies}
          refTechnologiesLoading={refTechnologiesLoading}
          jobs={jobs}
          selectedJob={selectedJob}
          onJobChange={onJobChange}
        />
      </div>
    </Modal>
  );
};

export default SalesInterviewsModal;
